export enum WorkOrderSubStatus {
  UnableToBeAutoAssigned = "UnableToBeAutoAssigned",
  Late = "Late",
  AtRisk = "AtRisk",
  Released = "Released",
}
